import React          from 'react';
import { makeStyles } from '@material-ui/core/styles';

const success = "המידע הועלה בהצלחה."

const useStyles = makeStyles(() => ({
    root: {
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        flexFlow:        'column',
        backgroundColor: '#FFF'
    },
    title: {
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       cursor:          'default',
       height:          40,
       fontSize:        18,
    },
    button: {
       width:           200,
       height:          45,
       margin:          20,
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       color:           '#FFF',
       backgroundColor: '#45C',
       fontWeight:      'bold',
       cursor:          'pointer',
       '&:hover': {
          opacity: 0.9
       }
    }
}))


type SuccessPropsType = {
    reset: () => void;
}

const SuccessPage: React.FC<SuccessPropsType> = ({ reset }) => {

    const classes = useStyles();

    return(
        <div className = { classes.root }>
            <div
               dir       = 'rtl'
               className = { classes.title }
            >
                { success }
            </div>
            <div
               className = { classes.button }
               onClick   = { reset }
            >
                אישור
            </div>
        </div>
    )
}

export default SuccessPage;